import { render } from "./nextcloud_body_banner7.vue?vue&type=template&id=5a2b5627&scoped=true"
import script from "./nextcloud_body_banner7.vue?vue&type=script&lang=js"
export * from "./nextcloud_body_banner7.vue?vue&type=script&lang=js"

import "./nextcloud_body_banner7.vue?vue&type=style&index=0&id=5a2b5627&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2b5627"]])

export default __exports__